module.exports = __webpack_public_path__ + "img/logo13.eb3adb5c.png";